import { useCallback } from 'react';

const useAsyncAction = (setErrorMsg) => {
  return useCallback(
    async (action, fallbackMsg) => {
      try {
        await action();
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errorMessage) {
          setErrorMsg(error.response.data.errorMessage);
        } else {
          setErrorMsg(fallbackMsg);
        }
      }
    },
    [setErrorMsg]
  );
};

export default useAsyncAction;
